import type { DeIdentificationRule, PromptContractConfig, PromptDiffEntry, PromptPreview } from '../../entities/ai-assist-config';
import { MASKED_BUNDLE_PLACEHOLDER, USER_PROMPT_PLACEHOLDER } from '../../entities/ai-assist-config';

export function renderPromptPreview(input: {
  promptContract: PromptContractConfig;
  maskedBundle: string;
  activeRules: DeIdentificationRule[];
  appliedRuleIds?: string[];
  userPromptText?: string;
}): PromptPreview {
  const userPromptText = input.userPromptText?.trim() ?? '';
  let renderedPrompt = input.promptContract.systemPromptTemplate.includes(MASKED_BUNDLE_PLACEHOLDER)
    ? input.promptContract.systemPromptTemplate.replace(MASKED_BUNDLE_PLACEHOLDER, input.maskedBundle)
    : `${input.promptContract.systemPromptTemplate}\n${input.maskedBundle}`;

  if (renderedPrompt.includes(USER_PROMPT_PLACEHOLDER)) {
    renderedPrompt = renderedPrompt.replace(USER_PROMPT_PLACEHOLDER, userPromptText);
  } else if (userPromptText) {
    renderedPrompt = `${renderedPrompt}\n\nUser prompt:\n${userPromptText}`;
  }

  const appliedRuleIds = input.appliedRuleIds ? new Set(input.appliedRuleIds) : null;
  const diffEntries: PromptDiffEntry[] = input.activeRules
    .filter((rule) => !appliedRuleIds || appliedRuleIds.has(rule.ruleId))
    .filter((rule) => rule.enabled && rule.conflictStatus === 'valid' && rule.originalValue !== rule.replacementValue)
    .map((rule) => ({
      diffId: rule.ruleId,
      beforeText: rule.originalValue,
      afterText: rule.replacementValue,
      changeType: 'masked',
      displayColorToken: 'accent',
    }));

  return {
    renderedPrompt,
    diffEntries,
    copiedAt: null,
    status: 'generated',
  };
}
